export default __webpack_public_path__ + "static/media/login-background.065f6c10.jpg";